import React from "react";
import stilePulsanti from "../../../interfaccia/stilePulsanti";

function RiquadrinoBrand({
    elemento,
    funzioneScegliID,
    scelto,
    rimuoviAssociazione
}) {

    const brand = elemento

    return (
        <div
            className={"sfondoBiancoTema br4 pa2 flex flex-wrap mb3 items-center"}
        >
            <div className="w-100 tl pa3 bb bordoColAlt tc">
                <strong className="f5">{brand.nome}</strong>
            </div>
            <div className="w-100 tl pa2 tc">
                {/* <div className="">{brand.fornitoriArray.length>0 && brand.fornitoriArray.map((brand,i)=>{
                return(
                    <span>{brand.fornitoriArray.length>1 && i>0 && ", "}{fornitore.nome}</span>)})}</div> */}
            </div>
            <div className="w-100 tl pa2 bordoColAlt tc">
            {/* {!scelto && <div className="">
                <button
                    className={stilePulsanti.buttonClassesWhite}
                    onClick={(e) => funzioneScegliID(brand.id, "idFornitore", 4, "brand", brand)}>
                    SCEGLI
                </button>
            </div>} */}
            {rimuoviAssociazione && <div className="">
                <div className="tooltip">
                <button
                    className={stilePulsanti.buttonClassesRed}
                    onClick={() => rimuoviAssociazione(brand.id)}>
                    X
                </button>
                <div class="tooltiptext">
                Rimuovi associazione {brand.id}
                </div>
                </div>
            </div>}
            
            </div>            
        </div>

    )
}

export default RiquadrinoBrand;

